import React, { useState } from "react";
import ProjectInfoButton from "../ProjectInfoButton/ProjectInfoButton";

// styles
import Style from "./ProjectInfoButtonContainer.module.css";

const ProjectInfoButtonContainer = ({ projectInfoSets }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredProjectInfoSets = projectInfoSets?.filter(
    (component) =>
      component.nameSurname.toLowerCase().includes(searchQuery.toLowerCase()) ||
      component.projectTitle
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      component.projectAcronym
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      component.id.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className={Style.ProjectInfoContainer}>
      <input
        className={Style.SearchInput}
        type="text"
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Pretraga po naslovu, ID, osobi ili akronimu"
      />
      {filteredProjectInfoSets?.map((projectInfo) => (
        <ProjectInfoButton key={projectInfo.id} projectInfo={projectInfo} />
      ))}
    </div>
  );
};

export default ProjectInfoButtonContainer;
